import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
// eslint-disable-next-line import/no-cycle
import { rootReducer, history } from './rootReducer';

const middleware = getDefaultMiddleware({
  immutableCheck: process.env.NODE_ENV !== 'production',
  serializableCheck: false,
  thunk: true,
}).concat(routerMiddleware(history));

export const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
